import React, { useState, useId } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type AccordionItemProps = {
  title: string;
  lines: string[];
  index: number;
  previewImage?: string;
  previewAlt?: string;
};
export function AccordionItem({
  title,
  lines,
  index,
  previewImage,
  previewAlt
}: AccordionItemProps) {
  const [open, setOpen] = useState(index === 0);
  const contentId = useId();
  return <article className="overflow-hidden rounded-xl border border-[#d8c8ad] bg-[#fffdf7] shadow-sm" data-id="element-1">
      {previewImage && <a href="#oferta" className="group relative block h-28 overflow-hidden border-b border-[#d8c8ad] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e56822] focus-visible:ring-inset" aria-label={`View offer for ${title}`} data-id="element-2">
          <img src={previewImage} alt={previewAlt ?? `Preview of ${title}`} className="h-full w-full object-cover object-top transition duration-300 group-hover:scale-[1.03]" data-id="element-3" />
          <span className="absolute inset-0 bg-[#10243d] opacity-20 transition-opacity duration-200 group-hover:opacity-10" aria-hidden="true" data-id="element-4" />
          <span className="absolute bottom-2 right-2 rounded bg-[#10243d] px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#fff8ea]" data-id="element-5">
            Bonus Preview
          </span>
        </a>}

      <h3 data-id="element-6">
        <button type="button" className="flex w-full items-center justify-between gap-4 p-4 text-left font-heading text-base font-bold uppercase tracking-wide text-[#10243d] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e56822] focus-visible:ring-inset" aria-expanded={open} aria-controls={contentId} onClick={() => setOpen(value => !value)} data-id="element-7">
          <span data-id="element-8">{title}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#e56822] transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-9" />
        </button>
      </h3>

      <AnimatePresence initial={false} data-id="element-10">
        {open && <motion.div id={contentId} role="region" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} data-id="element-11">
            <ul className="space-y-2 border-t border-[#eadfcd] px-4 pb-5 pt-3 text-sm leading-6 text-[#344658]" data-id="element-12">
              {lines.map(line => <li key={line} className="flex gap-2" data-id="element-13">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#e56822]" aria-hidden="true" data-id="element-14" />
                  <span data-id="element-15">{line}</span>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </article>;
}